import Loadable from '@loadable/component';

export const Box = Loadable(
	() => import(/* webpackChunkName: "Box", webpackPreload: true */ '@material-ui/core/Box')
);

export const Button = Loadable(
	() => import(/* webpackChunkName: "Button", webpackPreload: true */ '@material-ui/core/Button')
);

export const Collapse = Loadable(
	() =>
		import(
			/* webpackChunkName: "Collapse", webpackPreload: true */ '@material-ui/core/Collapse'
		)
);

export const Dialog = Loadable(
	() => import(/* webpackChunkName: "Dialog", webpackPreload: true */ '@material-ui/core/Dialog')
);
export const DialogTitle = Loadable(
	() =>
		import(
			/* webpackChunkName: "DialogTitle", webpackPreload: true */ '@material-ui/core/DialogTitle'
		)
);
export const DialogContent = Loadable(
	() =>
		import(
			/* webpackChunkName: "DialogContent", webpackPreload: true */ '@material-ui/core/DialogContent'
		)
);
export const DialogContentText = Loadable(
	() =>
		import(
			/* webpackChunkName: "DialogContentText", webpackPreload: true */ '@material-ui/core/DialogContentText'
		)
);
export const DialogActions = Loadable(
	() =>
		import(
			/* webpackChunkName: "DialogActions", webpackPreload: true */ '@material-ui/core/DialogActions'
		)
);

export const IconButton = Loadable(
	() =>
		import(
			/* webpackChunkName: "IconButton", webpackPreload: true */ '@material-ui/core/IconButton'
		)
);

export const Divider = Loadable<any>(
	() =>
		import(/* webpackChunkName: "Divider", webpackPreload: true */ '@material-ui/core/Divider')
);

export const InputAdornment = Loadable(
	() =>
		import(
			/* webpackChunkName: "InputAdornment", webpackPreload: true */ '@material-ui/core/InputAdornment'
		)
);

export const Typography = Loadable<any>(
	() =>
		import(
			/* webpackChunkName: "Typography", webpackPreload: true */ '@material-ui/core/Typography'
		)
);
export const CircularProgress = Loadable<any>(
	() =>
		import(
			/* webpackChunkName: "CircularProgress", webpackPreload: true */ '@material-ui/core/CircularProgress'
		)
);
export const Link = Loadable<any>(
	() => import(/* webpackChunkName: "Link", webpackPreload: true */ '@material-ui/core/Link')
);

export const Close = Loadable(
	() => import(/* webpackChunkName: "Close", webpackPreload: true */ '@material-ui/icons/Close')
);

export const CloudDownload = Loadable(
	() =>
		import(
			/* webpackChunkName: "CloudDownload", webpackPreload: true */ '@material-ui/icons/PrintOutlined'
		)
);

export const ArrowBack = Loadable(
	() =>
		import(
			/* webpackChunkName: "ArrowBack", webpackPreload: true */ '@material-ui/icons/ArrowBack'
		)
);

export const Warning = Loadable(
	() =>
		import(/* webpackChunkName: "Warning", webpackPreload: true */ '@material-ui/icons/Warning')
);

export const LockOpen = Loadable(
	() =>
		import(
			/* webpackChunkName: "LockOpen", webpackPreload: true */ '@material-ui/icons/LockOpen'
		)
);

export const Lock = Loadable(
	() => import(/* webpackChunkName: "Lock", webpackPreload: true */ '@material-ui/icons/Lock')
);

export const ArrowForward = Loadable(
	() =>
		import(
			/* webpackChunkName: "ArrowForward", webpackPreload: true */ '@material-ui/icons/ArrowForward'
		)
);

export const VisibilityOff = Loadable(
	() =>
		import(
			/* webpackChunkName: "VisibilityOff", webpackPreload: true */ '@material-ui/icons/VisibilityOff'
		)
);

export const Visibility = Loadable(
	() =>
		import(
			/* webpackChunkName: "Visibility", webpackPreload: true */ '@material-ui/icons/Visibility'
		)
);

export const ArrowForwardIos = Loadable(
	() =>
		import(
			/* webpackChunkName: "ArrowForwardIos", webpackPreload: true */ '@material-ui/icons/ArrowForwardIos'
		)
);

export const Email = Loadable(
	() => import(/* webpackChunkName: "Email", webpackPreload: true */ '@material-ui/icons/Email')
);

export const Done = Loadable(
	() => import(/* webpackChunkName: "Done", webpackPreload: true */ '@material-ui/icons/Done')
);

export const ArrowBackIos = Loadable(
	() =>
		import(
			/* webpackChunkName: "ArrowBackIos", webpackPreload: true */ '@material-ui/icons/ArrowBackIos'
		)
);

export const MessageTwoTone = Loadable(
	() =>
		import(
			/* webpackChunkName: "Visibility", webpackPreload: true */ '@material-ui/icons/MessageTwoTone'
		)
);

export const TextValidator = Loadable(
	() =>
		import(
			/* webpackChunkName: "TextValidator", webpackPreload: true */ 'react-material-ui-form-validator'
		),
	{
		resolveComponent: (component) => component.TextValidator
	}
);

export const ValidatorForm = Loadable(
	() =>
		import(
			/* webpackChunkName: "ValidatorForm", webpackPreload: true */ 'react-material-ui-form-validator'
		),
	{
		resolveComponent: (component) => component.ValidatorForm
	}
);
